import { createSlice } from '@reduxjs/toolkit';

const initState = {
	orgDefaultSettings: [],
	personDefaultSettings: [],
	groupSettingsData: [],

	orgDefaultSettingsLoading: false,
	personDefaultSettingsLoading: false,
	groupSettingsLoading: false,

	orgDefaultSettingsLoadingComplete: false,
	personDefaultSettingsLoadingComplete: false,
	groupSettingsLoadingComplete: false,

	error: null
};

const defaultSettingsSlice = createSlice({
	name: 'defaultSettings',
	initialState: initState,
	reducers: {
		loadOrgDefaultSettings: (state) => {
			state.orgDefaultSettingsLoading = true;
			state.error = null;
		},
		loadOrgDefaultSettingsSuccess: (state, action) => {
			state.orgDefaultSettings = action.payload;
			state.orgDefaultSettingsLoading = false;
			state.orgDefaultSettingsLoadingComplete = true;
		},
		loadOrgDefaultSettingsError: (state, action) => {
			state.orgDefaultSettingsLoading = false;
			state.error = action.payload;
		},
		loadPersonDefaultSettings: (state) => {
			state.personDefaultSettingsLoading = true;
			state.error = null;
		},
		loadPersonDefaultSettingsSuccess: (state, action) => {
			state.personDefaultSettings = action.payload;
			state.personDefaultSettingsLoading = false;
			state.personDefaultSettingsLoadingComplete = true;
		},
		loadPersonDefaultSettingsError: (state, action) => {
			state.personDefaultSettingsLoading = false;
			state.error = action.payload;
		},
		loadGroupSettings: (state) => {
			state.groupSettingsLoading = true;
			state.error = null;
		},
		loadGroupSettingsSuccess: (state, action) => {
			state.groupSettingsData = action.payload;
			state.groupSettingsLoading = false;
			state.groupSettingsLoadingComplete = true;
		},
		loadGroupSettingsError: (state, action) => {
			state.groupSettingsLoading = false;
			state.error = action.payload;
		}
	}
	// No need to reset the initial state as it is never changed
});

export const defaultSettingsActions = defaultSettingsSlice.actions;

export default defaultSettingsSlice.reducer;
